
import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Calendar, Clock, Tag } from 'lucide-react';

interface FeaturedPostProps {
  post: {
    title: string;
    slug: string;
    excerpt: string;
    date: string;
    readTime: string;
    image: string;
    category: string;
  };
  categoryName: string;
}

const FeaturedPost: React.FC<FeaturedPostProps> = ({ post, categoryName }) => {
  return (
    <Card className="transition-all hover:shadow-lg">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="aspect-video overflow-hidden">
          <img 
            src={post.image} 
            alt={post.title} 
            className="w-full h-full object-cover transition-transform hover:scale-105 duration-300"
          />
        </div>
        <div className="p-6 flex flex-col justify-center">
          <div className="flex items-center space-x-2 text-sm text-itmgmt-medium-blue mb-2">
            <Tag size={16} />
            <span>{categoryName}</span>
          </div>
          <h2 className="text-2xl font-bold mb-3 hover:text-itmgmt-medium-blue transition-colors">
            <Link to={`/blog/${post.slug}`}>
              {post.title}
            </Link>
          </h2>
          <p className="text-gray-600 mb-4">{post.excerpt}</p>
          <div className="flex items-center text-sm text-gray-500 mb-4">
            <Calendar size={14} className="mr-1" />
            <span className="mr-4">{post.date}</span>
            <Clock size={14} className="mr-1" />
            <span>{post.readTime}</span>
          </div>
          <Button asChild className="text-itmgmt-medium-blue hover:text-itmgmt-dark-blue bg-transparent hover:bg-itmgmt-light-blue/20 border border-current w-fit">
            <Link to={`/blog/${post.slug}`}>
              Read Featured Article
            </Link>
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default FeaturedPost;
